import { Link } from '@remix-run/react'
import { Button } from './ui/button'
import { Icon } from './ui/icon'

interface NoPageExistsProps {
	pathname: string | undefined
}

interface NoReviewExistsProps {
	reviewId: string | undefined
}

interface NoProductExistsProps {
	productId: string | undefined
}

interface NoUserExistsProps {
	username: string | undefined
}

export const NoPageExists = ({ pathname }: NoPageExistsProps) => (
	<div className="flex flex-col gap-6">
		<div className="flex flex-col gap-3">
			<h5 className="text-h5">Sorry, this page is on vacation😎:</h5>
			<pre className="whitespace-pre-wrap break-all text-lg">{pathname}</pre>
			<p className="text-lg font-normal">
				Maybe try again later when it's back at work?
			</p>
		</div>
		<Button variant={'link'} asChild>
			<Link to="/" prefetch="intent">
				<Icon name="arrow-left">
					<span className="text-sm">Back to home</span>
				</Icon>
			</Link>
		</Button>
	</div>
)

export const NoReviewExists = ({ reviewId }: NoReviewExistsProps) => (
	<div className="flex flex-col gap-6">
		<h5 className="text-h5">No review with the id "{reviewId}" exists</h5>
		<Button variant={'link'} asChild>
			<Link to="/" prefetch="intent">
				<Icon name="arrow-left">
					<span className="text-sm">Back to home</span>
				</Icon>
			</Link>
		</Button>
	</div>
)

export const NoProductExists = ({ productId }: NoProductExistsProps) => (
	<div className="flex flex-col gap-6">
		<h5 className="text-h5">No product with the id "{productId}" exists</h5>
		<Button variant={'link'} asChild>
			<Link to="/" prefetch="intent">
				<Icon name="arrow-left">
					<span className="text-sm">Back to home</span>
				</Icon>
			</Link>
		</Button>
	</div>
)

export const NoUserExists = ({ username }: NoUserExistsProps) => (
	<div className="flex flex-col gap-6">
		<div className="flex flex-col gap-3">
			<h5 className="text-h5">Sorry, this user is on vacation😎:</h5>
			<pre className="whitespace-pre-wrap break-all text-lg">{username}</pre>
			<p className="text-lg font-normal">
				Maybe try again later when it's back at work?
			</p>
		</div>
		<Button variant={'link'} asChild>
			<Link to="/" prefetch="intent">
				<Icon name="arrow-left">
					<span className="text-sm">Back to home</span>
				</Icon>
			</Link>
		</Button>
	</div>
)
